'use strict';
const angular = require('angular');

const uiRouter = require('angular-ui-router');

import routes from './apps.routes';

export class AppsComponent {
  constructor($http, $state, $scope, $window) {
    $scope.$state = $state;
    $http.get('/api/applications/my').then(res => { $scope.apps = res.data; });
  }
}

AppsComponent.$inject = ['$http', '$state', '$scope', '$window'];

export default angular.module('syncplicityLoginApp.apps', [uiRouter])
  .config(routes)
  .component('apps', {
    template: require('./apps.html'),
    controller: AppsComponent,
    controllerAs: 'appsCtrl'
  })
  .name;



// WEBPACK FOOTER //
// ./client/app/apps/apps.component.js